<template>
  <components :is="tabsContent[active].name"></components>
</template>

<script>
import cpjs from "@/components/small/cpjs.vue";
import tcgm from "@/components/small/tcgm.vue";
import tqip from "@/components/small/tqip.vue";
import cjwt from "@/components/small/cjwt.vue";
export default {
  props: {
    active: {
      tyepe: [Number, String],
      default: 0,
    },
  },
  components: {
    cpjs,
    tcgm,
    tqip,
    cjwt,
  },
  data() {
    return {
      tabsContent: [
        { id: 0, name: "cpjs" },
        { id: 1, name: "tcgm" },
        { id: 2, name: "tqip" },
        { id: 3, name: "cjwt" },
      ],
    };
  },
};
</script>
